import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const SymbolGoldIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-symbol-gold"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <g clipPath="url(#clip0_16192_34540)">
      <path
        d="M21.8651 9.29372L16.6057 2.50286C16.4255 2.2656 16.1846 2.08141 15.9084 1.96977C15.6322 1.85812 15.331 1.82316 15.0366 1.86857L6.77714 3.25143C6.18514 3.35429 5.68457 3.77715 5.46514 4.36686L2.47428 12.5486C2.36936 12.8385 2.33784 13.1499 2.3825 13.455C2.42717 13.7601 2.54665 14.0494 2.73028 14.2971L7.99542 21.0937C8.37257 21.5806 8.97142 21.8251 9.56342 21.728L17.8137 20.3451C18.4046 20.2423 18.9063 19.8194 19.1246 19.2297L22.1154 11.0491C22.2276 10.7597 22.2634 10.4463 22.2194 10.1391C22.1754 9.83184 22.053 9.5411 21.864 9.29486L21.8651 9.29372Z"
        fill="url(#paint0_linear_16192_34540)"
      />
      <path
        d="M15.2937 1.84798C15.7966 1.84798 16.2811 2.0857 16.6057 2.50284L21.8651 9.29255C22.2423 9.77941 22.3463 10.4526 22.1143 11.048L19.1246 19.2286C18.9051 19.8183 18.4046 20.24 17.8137 20.344L9.56342 21.7268C9.26922 21.7709 8.96859 21.7353 8.69281 21.6238C8.41704 21.5122 8.17622 21.3288 7.99542 21.0926L2.73142 14.2971C2.5476 14.0495 2.42801 13.7602 2.38333 13.4551C2.33866 13.1499 2.3703 12.8385 2.47542 12.5486L5.46399 4.3657C5.68342 3.77598 6.18399 3.35427 6.77599 3.25027L15.0366 1.86741C15.1223 1.8537 15.208 1.84684 15.2926 1.84684M15.2926 -0.00115967C15.1177 -0.00115967 14.9417 0.0136975 14.768 0.041126H14.7646L14.76 0.0422689L6.49827 1.42513H6.4937L6.49027 1.42741C5.29027 1.63541 4.26856 2.50284 3.82513 3.69255L3.82284 3.69713L3.82056 3.70284L0.830845 11.8857V11.888L0.829702 11.8903C0.614699 12.4773 0.549133 13.1086 0.638912 13.7273C0.728692 14.346 0.970995 14.9326 1.34399 15.4343L1.35542 15.448L1.3657 15.4628L6.63085 22.2583C7.29142 23.1097 8.26627 23.5954 9.30742 23.5954C9.48342 23.5954 9.65942 23.5806 9.83313 23.5531H9.8377L9.84113 23.552L18.0914 22.1691H18.096L18.0994 22.1668C19.2994 21.9588 20.3211 21.0914 20.7646 19.9017L20.7668 19.896L20.7691 19.8914L23.752 11.7257C23.9796 11.1309 24.051 10.4877 23.9594 9.8575C23.8677 9.22727 23.6161 8.63104 23.2286 8.1257L17.9714 1.33713C17.3086 0.48684 16.3337 -1.68107e-05 15.2926 -1.68107e-05V-0.00115967Z"
        fill="url(#paint1_linear_16192_34540)"
      />
      <path
        d="M15.2938 1.84799C15.7967 1.84799 16.2824 2.08571 16.6058 2.50285L21.8652 9.29371C22.2424 9.77942 22.3464 10.4526 22.1144 11.048L19.1247 19.2286C18.9052 19.8183 18.4047 20.2411 17.8138 20.344L9.56351 21.7269C9.26931 21.7709 8.96868 21.7353 8.69291 21.6238C8.41713 21.5122 8.17631 21.3288 7.99551 21.0926L2.73151 14.2971C2.54769 14.0495 2.4281 13.7602 2.38343 13.4551C2.33875 13.1499 2.37039 12.8385 2.47551 12.5486L5.46522 4.36799C5.68465 3.77828 6.18522 3.35657 6.77722 3.25371L15.0378 1.87085C15.1235 1.85599 15.2092 1.84914 15.2938 1.84914M15.2938 1.42285C15.1875 1.42285 15.0801 1.43199 14.9761 1.44799L6.71322 2.83199C6.34533 2.9003 6.00165 3.06351 5.71621 3.30545C5.43076 3.54739 5.21346 3.85969 5.08579 4.21142L2.09494 12.3943C1.96358 12.753 1.92374 13.1387 1.97901 13.5167C2.03429 13.8946 2.18294 14.2528 2.41151 14.5589L2.41379 14.5623L2.41608 14.5646L7.68122 21.3611C7.90478 21.6551 8.2034 21.8833 8.5457 22.0219C8.88799 22.1604 9.2613 22.2042 9.62637 22.1486L17.8778 20.7646C18.2453 20.6956 18.5885 20.532 18.8735 20.2899C19.1585 20.0478 19.3754 19.7355 19.5029 19.384L22.4927 11.2046C22.6321 10.8446 22.6765 10.4548 22.6216 10.0727C22.5668 9.69062 22.4145 9.32907 22.1795 9.02285L16.9201 2.23428C16.7294 1.98337 16.4835 1.77969 16.2015 1.63899C15.9195 1.49829 15.6089 1.42434 15.2938 1.42285Z"
        fill="url(#paint2_linear_16192_34540)"
      />
      <path
        opacity="0.2"
        d="M22.9269 13.9828L20.7692 19.8868L20.7669 19.8925L20.7646 19.8983C20.3224 21.0868 19.3006 21.9554 18.1006 22.1623L18.0961 22.1645H18.0915L12.9132 23.0331L5.60693 15.3623L9.83322 10.8937L13.0309 12.8525L15.4744 9.2914L17.6172 8.41711L22.9269 13.9828Z"
        fill="url(#paint3_linear_16192_34540)"
      />
      <path
        d="M14.4022 7.82858L12.5485 11.2366L10.7176 7.20001L8.42964 7.81487L5.60449 15.3623H8.12449L9.83192 10.9097L11.4994 15.144H12.7919L15.2685 10.608V16.4183L17.6182 15.5989V8.41715L14.4022 7.82858Z"
        fill="url(#paint4_linear_16192_34540)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_16192_34540"
        x1="18.7394"
        y1="19.8549"
        x2="5.11428"
        y2="4.38857"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D98E32" />
        <stop offset="1" stopColor="#FFD700" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_16192_34540"
        x1="12.2994"
        y1="23.5966"
        x2="12.2994"
        y2="-1.76182e-05"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BF5E26" />
        <stop offset="1" stopColor="#FFD700" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_16192_34540"
        x1="1.95551"
        y1="11.7977"
        x2="22.6435"
        y2="11.7977"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BF5E26" />
        <stop offset="1" stopColor="#FFD700" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_16192_34540"
        x1="5.60693"
        y1="15.7177"
        x2="22.9269"
        y2="15.7177"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#552300" stopOpacity="0.9" />
        <stop offset="1" stopColor="#BF5E26" stopOpacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_16192_34540"
        x1="15.8331"
        y1="17.1714"
        x2="7.95649"
        y2="8.23201"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F2D88A" />
        <stop offset="0.04" stopColor="#F3DC97" />
        <stop offset="0.15" stopColor="#F7E7B7" />
        <stop offset="0.26" stopColor="#F9EFD1" />
        <stop offset="0.39" stopColor="#FCF6E5" />
        <stop offset="0.53" stopColor="#FDFBF4" />
        <stop offset="0.71" stopColor="#FEFEFC" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_16192_34540">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </Svg>
));

SymbolGoldIcon.displayName = 'SymbolGoldIcon';
